const NotificationsType = {
  User: 'mine',
  All: 'all'
}

export default NotificationsType
